export default "__VITE_ASSET__D8ec1TT4__"